import React from 'react';
import { Loader2 } from 'lucide-react';

const PageLoader = ({ label = 'Chargement...' }) => (
  <div className="flex flex-col items-center justify-center py-24 min-h-[40vh] gap-3" role="status" aria-live="polite">
    <Loader2 className="w-10 h-10 animate-spin text-chantilly-gold" />
    <span className="text-chantilly-cream/70 text-sm">{label}</span>
  </div>
);

export default PageLoader;
